import qs from 'qs'
import { DispatcherResponse } from '../../typings/ReduxDispatch'
import { actions } from './reducer'

class Dispatcher {
  actions = actions

  install(): DispatcherResponse<any> {
    return async (dispatch) => {
      const qStr = location.search || ''
      const params = qs.parse(qStr.replace('?', '')) || {}

      if (params.email) dispatch(actions.setEmail(params.email as string))
      if (params.phone_number) dispatch(actions.setPhoneNumber(params.phone_number as string))
    }
  }

  // checkEmail(email: string): DispatcherResponse<boolean> {
  //   return async (dispatch) => {
  //     let isEmailAvailable = false
  //     try {
  //       const recaptcha = await load(config.recaptchaSiteKey)
  //       const token = await recaptcha.execute('onboard_email')
  //
  //       const { data } = await api.onboardCheckEmailCreate({
  //         email,
  //         recaptcha: token,
  //         analytics_ref: analyst.client_id,
  //       })
  //       if (data.redirect) {
  //         navigationUtil.navigateToHrLogin(email)
  //       } else {
  //         isEmailAvailable = true
  //       }
  //     } catch (e) {
  //       const { status } = apiErrorUtil.getRequestInfo(e)
  //       const code = apiErrorUtil.getErrorCodeFromApi(e)
  //
  //       console.log('error:', status, code)
  //
  //       throw e
  //     }
  //
  //     return isEmailAvailable
  //   }
  // }
}

const FormDispatcher = new Dispatcher()
export default FormDispatcher
